<template>
  <div>
    <vue-good-table
        :columns="columnsCorrespondence"
        :rows="rowsCorrespondence"
        :globalSearch="false"
        :paginate="false"
    >
      <template slot="table-row" slot-scope="props">
        <div v-if="props.row.type !== 'messages' || user.twilioStatus">
          <div v-if="props.column.field === 'action'">
            <actions-menu>
              <actions-menu-item
                title="Export PDF"
                icon="fa-file-pdf-o"
                :href="getDownloadUrl(props.row.type, 'pdf')"
              />
              <actions-menu-item
                title="Export XLS"
                icon="fa-file-excel-o"
                :href="getDownloadUrl(props.row.type, 'xls')"
              />
              <actions-menu-item
                title="Export CSV"
                :href="getDownloadUrl(props.row.type, 'csv')"
                icon-src="/static/global/img/csv-ico.svg"
              />
            </actions-menu>
          </div>
          <span v-else>{{props.formattedRow[props.column.field]}}</span>
        </div>
      </template>
    </vue-good-table>
    <br>`
    <router-link :to="{ name: 'Dashboard Participant', params: { id: $route.params.id } }" tag="button"
                 type="button" class="btn green" v-if="$route.params.id != null">
      {{ participantSingularName }} Dashboard
    </router-link>
  </div>
</template>

<script>
import {URL} from '@/http-common';
import participantDisplayName from '@/mixins/participantDisplayName';
import ActionsMenu from "../../components/reusables/ActionsMenu";
import ActionsMenuItem from "../../components/reusables/ActionsMenuItem";

export default {
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  mixins: [
    participantDisplayName
  ],
  components: {
    ActionsMenu,
    ActionsMenuItem,
  },
  data () {
    return {
      columnsCorrespondence: [
        {
          label: 'Name',
          field: 'name'
        },
        {
          label: 'Action',
          field: 'action'
        },
      ],
      rowsCorrespondence: [
        {
          name: 'Communication Notes',
          type: 'notes'
        },
        {
          name: 'Participant File',
          type: 'forms'
        },
        {
          name: 'SMS Messaging',
          type: 'messages'
        },
      ],
    }
  },
  methods: {
    getDownloadUrl(type, format) {
      let url = `${URL}/${type}/history/export?pid=${this.$route.params.id}&type=${format}&token=${localStorage.getItem('id_token')}`;

      if (this.$route.params.historyid !== undefined) {
        url += `&aid=${this.$route.params.historyid}`
      }

      return url
    }
  }
}
</script>



// WEBPACK FOOTER //
// Correspondence.vue?66fbdbe2